import { SortOrder } from "../sort-order";

export class AuditFilters {
  sortField: string;
  sortOrder: SortOrder;

  public getOrder(){
    return this.sortOrder?.valueOf() ? 'asc' : 'desc';
  }
}
